import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { allapiAction } from "../../Redux/common/action";
import moment from "moment";
import { URL } from "../../Redux/common/url";
import {
  FaFacebook,
  FaInstagram,
  FaWhatsapp,
} from "react-icons/fa";

function BlogDetailsPub() {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const blog_details = useSelector(
    (state) => state?.allapi?.blog_details || {}
  );

  const get_recent_blog_list = useSelector(
    (state) => state?.allapi?.get_recent_blog_list || []
  );

  useEffect(() => {
    dispatch(allapiAction.getrectentBlog({}));
  }, []);

  useEffect(() => {
    if (id) {
      dispatch(allapiAction.getBlogDetails({ id }));
    }
  }, [id]);

  return (
    <div className="blgDtl">
      {/* ===== BANNER ===== */}
      <div
        style={{
          backgroundImage:
            "url(https://creatosoftware.com/public/uploads/news-banner-12.jpg)",
          backgroundSize: "cover",
          backgroundPosition: "center",
          minHeight: "40vh",
          color: "#fff",
          textAlign: "center",
          fontWeight: "800",
          boxShadow: "inset 0 0 0 1000px rgba(0,0,0,0.45)",
          borderBottomLeftRadius: "20px",
          borderBottomRightRadius: "20px",
          padding: "110px 20px 50px",
        }}
      >
        <h1
          style={{
            fontSize: "clamp(2.2rem, 5vw, 3.4rem)",
            lineHeight: "1.3",
            letterSpacing: "0.6px",
            margin: 0,
          }}
        >
          {blog_details?.title}
        </h1>
      </div>

      {/* ===== CONTENT ===== */}
      <div style={{ background: "#f2f4f8", padding: "60px 0" }}>
        <div className="container">
          <div className="row gx-5">
            {/* ===== LEFT ===== */}
            <div className="col-md-8">
              <div
                style={{
                  background: "#fff",
                  padding: "2.8rem",
                  borderRadius: "14px",
                  boxShadow: "0 10px 25px rgba(0,0,0,0.08)",
                  borderLeft: "6px solid #000",
                }}
              >
                <img
                  src={URL?.API_BASE_URL + blog_details?.feature_image}
                  alt="Blog"
                  style={{
                    width: "100%",
                    maxHeight: "65vh",
                    objectFit: "cover",
                    borderRadius: "14px",
                    marginBottom: "30px",
                  }}
                />

                <h3
                  style={{
                    fontSize: "2rem",
                    fontWeight: "800",
                    color: "#111",
                    marginBottom: "20px",
                    lineHeight: "1.4",
                  }}
                >
                  {blog_details?.title}
                </h3>

                <p
                  style={{
                    fontSize: "1rem",
                    color: "#21014b !important",
                    marginBottom: "30px",
                  }}
                >
                  {moment(blog_details?.createdAt).format("MMM DD, YYYY")}
                </p>

                {/* ===== BLOG TEXT ===== */}
                <div
                  style={{
                    fontSize: "1.15rem",
                    lineHeight: "2.1",
                    color: "#222",
                    letterSpacing: "0.35px",
                    wordSpacing: "1px",
                  }}
                  dangerouslySetInnerHTML={{
                    __html: blog_details?.description,
                  }}
                />

                {/* ===== SHARE ===== */}
                <div style={{ marginTop: "40px" }}>
                  <h5
                    style={{
                      fontWeight: "800",
                      marginBottom: "15px",
                    }}
                  >
                    Share This Post
                  </h5>

                  <div style={{ display: "flex", gap: "12px" }}>
                    <a
                      href={`https://api.whatsapp.com/send?text=${encodeURIComponent(
                        blog_details?.title + " " + window.location.href
                      )}`}
                      target="_blank"
                      rel="noreferrer"
                      style={{
                        width: "46px",
                        height: "46px",
                        background: "#25D366",
                        color: "#fff",
                        borderRadius: "50%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <FaWhatsapp size={22} />
                    </a>

                    <a
                      href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
                        window.location.href
                      )}`}
                      target="_blank"
                      rel="noreferrer"
                      style={{
                        width: "46px",
                        height: "46px",
                        background: "#3b5998",
                        color: "#fff",
                        borderRadius: "50%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <FaFacebook size={22} />
                    </a>

                    <a
                      href={`https://www.instagram.com/?url=${encodeURIComponent(
                        window.location.href
                      )}`}
                      target="_blank"
                      rel="noreferrer"
                      style={{
                        width: "46px",
                        height: "46px",
                        background:
                          "radial-gradient(circle at 30% 107%, #fdf497 0%, #fdf497 5%, #fd5949 45%, #d6249f 60%, #285AEB 90%)",
                        color: "#fff",
                        borderRadius: "50%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <FaInstagram size={22} />
                    </a>
                  </div>
                </div>
              </div>
            </div>

            {/* ===== RIGHT ===== */}
            <div className="col-md-4">
              <div
                style={{
                  background: "#fff",
                  padding: "25px",
                  borderRadius: "12px",
                  boxShadow: "0 6px 18px rgba(0,0,0,0.06)",
                }}
              >
                <h5
                  style={{
                    fontSize: "1.25rem",
                    fontWeight: "800",
                    marginBottom: "25px",
                  }}
                >
                  RECENT POSTS
                </h5>

                {get_recent_blog_list.map((data, i) => (
                  <div
                    key={i}
                    style={{
                      display: "flex",
                      marginBottom: "18px",
                      cursor: "pointer",
                    }}
                    onClick={() =>
                      navigate("/blog-details/" + data?.slug)
                    }
                  >
                    <img
                      src={URL?.API_BASE_URL + data?.feature_image}
                      alt="recent"
                      style={{
                        width: "80px",
                        height: "80px",
                        objectFit: "cover",
                        borderRadius: "8px",
                        marginRight: "12px",
                      }}
                    />
                    <div>
                      <p
                        style={{
                          fontSize: "1rem",
                          fontWeight: "600",
                          marginBottom: "5px",
                          lineHeight: "1.4",
                        }}
                      >
                        {data?.title}
                      </p>
                      <p
                        style={{
                          fontSize: "0.85rem",
                          color: "#0c1457 !important",
                        }}
                      >
                        {moment(data?.createdAt).format(
                          "MMM DD, YYYY"
                        )}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BlogDetailsPub;
